import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {Select} from 'primeng/select';
import {TranslatePipe} from '@ngx-translate/core';
import {LANGUAGES, LANGUAGES_MANDATORY} from '../../../../../assets/domains/domains';

@Component({
  selector: 'app-language-dropdown',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    Select,
    TranslatePipe
  ],
  templateUrl: './language-dropdown.component.html',
  styleUrl: './language-dropdown.component.scss'
})
export class LanguageDropdownComponent implements OnInit
{
  @Input() languages: any[];

  @Input() valueType: string;
  @Input() showClear: boolean;
  @Input() selectedLanguage: any;
  @Input() class: string;
  @Input() styleClass: string;
  @Input() fieldName: string;
  @Input() form: UntypedFormGroup;
  @Output() selectedLanguageChange = new EventEmitter<any>();

  @Output() languageChange = new EventEmitter<any>();

  ngOnInit(): void
  {
    console.log('ngOnInit, languages: ', this.languages);
    if (!this.languages || this.languages.length === 0)
    {
      if (this.showClear)
        this.languages = LANGUAGES;
      else this.languages = LANGUAGES_MANDATORY;
    }
  }

  public onLanguageChange(): void
  {
    this.selectedLanguageChange.emit(this.selectedLanguage);
    this.languageChange?.emit(this.selectedLanguage);
  }

  public convertFlagCode(code: string): string
  {
    if (!code)
      return code;

    code = code.toLowerCase();
    if (code === 'en')
      return 'gb';
    return code;
  }
}
